import moment from 'moment';

export function formatHoursMinutes(value: string): string {
  return moment(value, 'HHmm').clone().format('HH:mm');
}

export function formatHoursMinutesWithDuration(value: string, duration: number): string {
  return moment(value, 'HHmm').clone().add(duration, 'minutes').format('HH:mm');
}
